import { DatePipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner'
import {
  DataPageOfFinancial,
  DataPageOfTransaction,
  Financial,
  Transaction,
  UiPreferences,
} from '../../../../../api/models'
import {
  AppSettingService,
  ColumnChooserService,
  FinancialService,
  TransactionService,
} from '../../../../../api/services'
import { validateAllFormFields } from '../../../../../formUtils'
import { Customsort } from '../../../../directives/customsort'

import { ConfirmationService, MessageService, SortEvent } from 'primeng/api'
import { CareFinitySession } from '../../../../services/CareFinitySession'

@Component({
  selector: 'app-financial-list',
  templateUrl: './financial-list.component.html',
  styleUrls: ['./financial-list.component.css'],
})
export class FinancialListComponent implements OnInit {
  Item = 'Financials'
  finansummary: DataPageOfFinancial

  listTransaction: DataPageOfTransaction
  selectedPatient: Financial
  Lastpageindex: number = 1
  rows: number
  _selectedColumns: any[]

  private cols: any[]
  colsTrans: any[]
  othercol: any[]
  transactionsForm
  public activeIndex: number = 0

    popupheader: string = 'Post Transaction';

    preferences: UiPreferences = {};

  displaypopupTransactions_AddEdit: boolean = false
  showRecordsFinancialSummary: boolean = false
  showRecordsArchiveTransaction: boolean = false
  // yearRangeForDatePicker: string;

  transaction: Transaction
  isEdit: boolean = false
  selectedId: number = -1
  transactionTypes: { text: string; value: string }[] = [
    { text: 'Adjustment', value: 'Adjustment' },
    { text: 'Payments', value: 'Payments' },
  ]

  transactionSources: { text: string; value: string }[] = [
    { text: 'COB1', value: 'COB1' },
    { text: 'COB2', value: 'COB2' },
    { text: 'COB3', value: 'COB3' },
    { text: 'Patient', value: 'Patient' },
    { text: 'Bad Debt', value: 'Bad Debt' },
  ]
  isArchiveInstance: boolean

  shouldtotalBeVisible(col) {
    return this.selectedColumns.map((i) => i.field).includes(col)
  }

  get selectedColumns() {
    return this._selectedColumns
  }

  set selectedColumns(val: any[]) {
    let selectedValues = [...val]

    if (selectedValues.length == 0) {
      selectedValues = this._selectedColumns = [this.cols[0]]
    } else {
      //restore original order

      this._selectedColumns = val
    }

    let filteredData = Array.prototype.map
      .call(selectedValues, (s) => s.field)
      .toString()
    let filteredValue = Array.prototype.map
      .call(selectedValues, (s) => s.header)
      .toString()

    this.columnChooserService
      .columnChooserColumnchooser({
        columnNames: filteredData,
        columnValue: filteredValue,
        type: 'Financials',
      })
      .subscribe((result) => {})
  }

    calculateColSpan() {
        const filteredArray = this.selectedColumns
            .map((i) => i.field)
            .filter((value) =>
                ['enCounterNo', 'billableDate', 'renderingProvider'].includes(value),
            )

        return filteredArray.length + 1 + ''
    }

  constructor(
    private columnChooserService: ColumnChooserService,
    private appSettingsService: AppSettingService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private fnservice: FinancialService,
    private transactionService: TransactionService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private cstsort: Customsort,
    private confirmation: ConfirmationService,
    private messageService: MessageService,
  ) {
    this.transactionsForm = this.fb.group({
      transactionType: new UntypedFormControl(null, [Validators.required]),
      transactionDate: new UntypedFormControl(null),
      encounterNo: new UntypedFormControl(null),
      transactionAmount: new UntypedFormControl(null),
      transactionSource: new UntypedFormControl(null),
      notes: new UntypedFormControl(null),
    })
  }

  ngOnInit() {
    this.isArchiveInstance =
      CareFinitySession.practiceSettings.isArchiveInstance
    this.cols = [
      { field: 'enCounterNo', header: 'Encounter No', sort: 1 },
      { field: 'billableDate', header: 'Visit Date', sort: 1 },
      { field: 'renderingProvider', header: 'Rendering Provider', sort: 1 },
      { field: 'charge', header: 'Charge AMT' },
      { field: 'paid', header: 'Paid AMT' },
      { field: 'adjustement', header: 'Adjustment AMT' },
      { field: 'coB1', header: 'COB1 AMT' },
      { field: 'coB2', header: 'COB2 AMT' },
      { field: 'coB3', header: 'COB3 AMT' },
      { field: 'pat', header: 'Pat AMT' },
      { field: 'badDebit', header: 'Bad Debt AMT' },
    ]

    this.colsTrans = [
      { field: 'transactionDate', header: 'Date' },
      { field: 'transactionType', header: 'Type' },
      { field: 'encounterNo', header: 'Encounter #' },
      { field: 'transactionAmount', header: 'Amount' },
      { field: 'transactionSource', header: 'Source' },
      { field: 'notes', header: 'Notes' },
      ]



    this._selectedColumns = this.cols

    // this.yearRangeForDatePicker = environment.yearRangeForDatePicker;
    this.financialList(1, 'Desc')
    this.activeIndex = 0
      this.getTransactionList();

      

      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          this.Item = this.preferences?.financials || 'Financials';
      }
  }
  calculateGroupTotal(obj) {
    switch (obj) {
      case 'tc':
        return this.finansummary.data[0].total_Charge
      case 'tp':
        return this.finansummary.data[0].total_Paid
      case 'ta':
        return this.finansummary.data[0].total_Adjustement
      case 'tcob1':
        return this.finansummary.data[0].total_COB1
      case 'tcob2':
        return this.finansummary.data[0].total_COB2
      case 'tcob3':
        return this.finansummary.data[0].total_COB3
      case 'tpat':
        return this.finansummary.data[0].total_Pat
      case 'tbad':
        return this.finansummary.data[0].total_BadeDebit
      default:
        return '0.00'
    }
  }
  financialList(pageNumber: number, sortbydirection: string) {
    this.fnservice
      .financialGetFinacialList({
        PatientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
      })
      .subscribe((result) => {
        console.log(result)
        this.finansummary = result
        this.rows = this.finansummary.pageSize

        if (this.finansummary.data.length > 0) {
          this.showRecordsFinancialSummary = true
        } else {
          this.showRecordsFinancialSummary = false
        }

        if (result.savedColumns) {
          let savedColumns = result.savedColumns.split(',')

          this._selectedColumns = this.cols.filter((i) =>
            savedColumns.includes(i.field),
          )
        }
      })
  }

  getTransactionList() {
    this.transactionService.transactionList().subscribe((trsnResp) => {
      this.listTransaction = trsnResp
      if (this.listTransaction.data.length > 0) {
        this.showRecordsArchiveTransaction = true
      } else {
        this.showRecordsArchiveTransaction = false
      }
    })
  }

  saveTransaction() {
    const patientId = sessionStorage.getItem('ptId')
    const practiceId = localStorage.getItem('EmrPracticeId')

    validateAllFormFields(this.transactionsForm)

    if (this.transactionsForm.invalid) {
      return
    }

    const transactionDateValue =
      this.transactionsForm.get('transactionDate').value

    // Check if the value is not null or undefined
    if (transactionDateValue) {
      // Format the date
      const formattedDate = this.formatDate(transactionDateValue)

      // Set the formatted date back to transactionsForm
      this.transactionsForm.get('transactionDate').setValue(formattedDate)
    } else {
      // Handle the case where transactionDateValue is null or undefined
      console.error('Transaction date value is null or undefined.')
    }
    //.setValue(transactionType);

    if (!this.isEdit) {
      this.transactionService
        .transactionCreateTransaction({
          body: { patientId, practiceId, ...this.transactionsForm.value },
        })
        .subscribe(
          (result) => {
            //// this.messageService.add({ key: 'alertToast', severity: 'success', detail: "Roles Added successfully", summary: 'Confirmation', life: 5000 });
            //this.router.navigate(['Patient/financial/list']);

            //this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            //    this.router.navigate(['Patient/financial/list'], { skipLocationChange: true });
            //});
            this.transactionsForm.reset()
            this.getTransactionList()
          },
          (error) => {
            //console.error('error caught in component')
            // this.messageService.add({ key: 'alertToast', severity: 'danger', detail: "Error ! Roles Added failed", summary: 'Confirmation', life: 5000 });
          },
        )
    } else {
      this.transactionService
        .transactionPut2({
          id: this.selectedId,
          body: { patientId, practiceId, ...this.transactionsForm.value },
        })
        .subscribe(
          (result) => {
            ////// this.messageService.add({ key: 'alertToast', severity: 'success', detail: "Roles Added successfully", summary: 'Confirmation', life: 5000 });
            //this.router.navigate(['Patient/financial/list']);

            //this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            //    this.router.navigate(['Patient/financial/list'], { skipLocationChange: true });
            //});
            this.transactionsForm.reset()
            this.getTransactionList()
          },
          (error) => {
            //console.error('error caught in component')
            // this.messageService.add({ key: 'alertToast', severity: 'danger', detail: "Error ! Roles Added failed", summary: 'Confirmation', life: 5000 });
          },
        )
      this.transactionsForm.reset()
    }
    this.displaypopupTransactions_AddEdit = false
    this.activeIndex = 1
    // this.getTransactionList();
  }

  getfinancialDetails(enCounterNo, billableDate, renderingProvider) {
    this.router.navigate(['Patient/financial/details'], {
      queryParams: {
        enc_no: enCounterNo,
        ren_provider: renderingProvider,
        billing_date: billableDate,
      },
      skipLocationChange: true,
    })
  }

  addTransation_click() {
    this.displaypopupTransactions_AddEdit = true
  }
  onEditTransation(event, id: number) {
    this.transactionsForm.reset()

    this.isEdit = true
    this.selectedId = id
    this.displaypopupTransactions_AddEdit = true
    this.transactionService
      .transactionGetCarefinityTransaction({ id: id })
      .subscribe((res) => {
        this.transaction = res

        // Check for null and undefined values before setting form values
        const transactionType =
          this.transaction && this.transaction['transactionType'] !== undefined
            ? this.transaction['transactionType']
            : null
        const transactionDate =
          this.transaction && this.transaction['transactionDate'] !== undefined
            ? this.transaction['transactionDate']
            : null
        const encounterNo =
          this.transaction && this.transaction['encounterNo'] !== undefined
            ? this.transaction['encounterNo']
            : null
        const transactionAmount =
          this.transaction &&
          this.transaction['transactionAmount'] !== undefined
            ? this.transaction['transactionAmount']
            : null
        const transactionSource =
          this.transaction &&
          this.transaction['transactionSource'] !== undefined
            ? this.transaction['transactionSource']
            : null
        const notes =
          this.transaction && this.transaction['notes'] !== undefined
            ? this.transaction['notes']
            : null

        // Set form values
        this.transactionsForm.get('transactionType').setValue(transactionType)
        this.transactionsForm.get('transactionDate').setValue(transactionDate)
        this.transactionsForm.get('encounterNo').setValue(encounterNo)
        this.transactionsForm
          .get('transactionAmount')
          .setValue(transactionAmount)
        this.transactionsForm
          .get('transactionSource')
          .setValue(transactionSource)
        this.transactionsForm.get('notes').setValue(notes)
      })
  }
  onDeleteTransation(event, transationid: number) {
    this.confirmation.confirm({
      key: 'delete_confirmation',
      message: 'Are you sure you want to delete this Transation?',
      accept: () => {
        this.deleteTransation(transationid)
        this.listTransaction.data = this.listTransaction.data.filter(
          (i) => i.transactionId != transationid,
        )
      },
    })
  }

  deleteTransation(transationid) {
    debugger
    this.transactionService
      .transactionDelete({
        id: transationid,
      })
      .subscribe((data) => {
        this.messageService.add({
          key: 'alertToast',
          severity: 'success',
          summary: 'Confirmation!',
          detail: 'Transation Deleted Successfully',
          life: 5000,
        })
      })
  }
  customSort(event: SortEvent, num: number) {
    console.log(event)
    this.finansummary.data = this.cstsort.generalcustomSort(
      event,
      this.finansummary.data,
    )
  }

  formatDate(isoDate: string): string {
    const date = new Date(isoDate)
    const month = date.getMonth() + 1
    const day = date.getDate()
    const year = date.getFullYear()

    // Ensure leading zeros for single digit months and days
    const formattedMonth = month < 10 ? '0' + month : month
    const formattedDay = day < 10 ? '0' + day : day

    return `${formattedMonth}/${formattedDay}/${year}`
  }
}
